import OtpConfirmModal from "./otp-confirm-modal.component";

export default OtpConfirmModal;
